import type { SizeType } from "../types/size";

export const sizeClasses = (size: SizeType | undefined) => {
  if (!size) {
    return {};
  }

  return {
    "--is-xxs": size === "xxs",
    "--is-xs": size === "xs",
    "--is-sm": size === "sm",
    "--is-md": size === "md",
    "--is-lg": size === "lg",
    "--is-xl": size === "xl",
    "--is-xxl": size === "xxl",
  };
};
